export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9698_NOTE': 'Note',
    '_7424_DELETE': 'Delete',
    '_9492_WARNING': 'Warning',
    '_9699_DISCARD_CHANGES_': 'Discard changes?',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9700_NOTE_TYPE_': 'Note Type:',
    '_9800_THE_TEXT_IS_REQUIRED': 'The text is required'
};
